/**
 * @fileoverview Shared Weight schema used by both frontend and backend.
 */

import { z } from 'zod';
import { commonValidators, createCrudSchemas, createEntityIdSchema, createdAtSchema, deletedAtSchema, getSchemaFields, updatedAtSchema } from './base.js';
import { ID_PATTERNS } from './types.js';

/**
 * Weight validation schema
 */
export const WeightSchema = z.object({
  id: createEntityIdSchema(ID_PATTERNS.WEIGHT, 'ID must be in we-prefixed nanoid7 format'),
  recorded_date: commonValidators.dateString(),
  weight_lbs: z.number()
    .min(50.01, 'Weight must be greater than 50 lbs')
    .max(600, 'Weight must be less than or equal to 600 lbs'),
  weight_kg: z.number().optional().nullable(), // Generated column
  weight_st: z.number().optional().nullable(), // Generated column
  notes: commonValidators.optionalString(1000),
  metadata: commonValidators.jsonField('Metadata'),
  deleted_at: deletedAtSchema,
  created_at: createdAtSchema,
  updated_at: updatedAtSchema,
});

// Weight has generated columns (weight_kg, weight_st) that should be omitted from Create
const { CreateSchema, UpdateSchema } = createCrudSchemas(WeightSchema, {
  additionalOmit: ['weight_kg', 'weight_st'],
});

export const WeightCreateSchema = CreateSchema;
export const WeightUpdateSchema = UpdateSchema;

export type Weight = z.infer<typeof WeightSchema>;
export type WeightCreate = z.infer<typeof WeightCreateSchema>;
export type WeightUpdate = z.infer<typeof WeightUpdateSchema>;

export const WEIGHT_FIELDS = getSchemaFields(WeightSchema);
